import { DateTime } from 'luxon';
import { AutocompleteOption } from 'redesign';
import { getBranchOffices, getDepartments, getJobTypes } from '../../../shifts/filters/utils/utils';
import {
  ProjectPlanningFiltersData,
  ProjectPlanningFiltersFormType,
} from '../project-planning-filters.types';
import { ProjectPlanningPageParams } from '../../table/hooks/use-project-planning.types';

const getProjectPlanningFiltersDefaultValues = (
  appliedFilters: ProjectPlanningPageParams,
  filterData: ProjectPlanningFiltersData
): ProjectPlanningFiltersFormType => {
  const toDate = appliedFilters.toDate
    ? appliedFilters.toDate.toFormat('yyyy-MM-dd')
    : DateTime.now().toFormat('yyyy-MM-dd');
  const result: ProjectPlanningFiltersFormType = {
    toDate,
    company: null,
    branchOffices: null,
    departments: null,
    jobType: null,
    isFreelance: appliedFilters.isFreelance ?? false,
    isTempWork: appliedFilters.isTempWork ?? false,
    areFreelanceApplications: appliedFilters.areFreelanceApplications ?? false,
    areTempworkApplications: appliedFilters.areTempworkApplications ?? false,
    areNoApplications: appliedFilters.areNoApplications ?? false,
    filledStatusCheckboxValue: !!appliedFilters.filledStatus,
    jobTypeCheckboxValue: !!appliedFilters.jobType?.length,
    filledStatus: appliedFilters.filledStatus ? appliedFilters.filledStatus : 'inProgress',
    businessUnitCheckboxValue: !!appliedFilters.company,
    toDateCheckboxValue: !!appliedFilters.toDate,
    employmentTypeCheckboxValue: !!appliedFilters.isFreelance || !!appliedFilters.isTempWork,
    applicationTypesCheckboxValue:
      !!appliedFilters.areFreelanceApplications ||
      !!appliedFilters.areTempworkApplications ||
      !!appliedFilters.areNoApplications,
  };

  if (appliedFilters.jobType?.length) {
    const jobTypes = getJobTypes(appliedFilters.jobType, filterData.jobTypes);
    if (jobTypes?.length) {
      result.jobType = jobTypes.map((jt) => ({ id: jt.value, name: jt.label }));
    }
  }
  const allBranchOffices = filterData.companies.flatMap((c) => c.branchOffices ?? []);

  if (appliedFilters.branchOffices?.length) {
    result.branchOffices = getBranchOffices(appliedFilters.branchOffices, allBranchOffices);
  }

  if (appliedFilters.departments?.length) {
    result.departments = getDepartments(appliedFilters.departments, allBranchOffices);
  }

  if (!appliedFilters.company) {
    return result;
  }
  if (!filterData?.companies) {
    return result;
  }
  const companyFilter = filterData.companies.find((c) => c.companyId === appliedFilters.company);

  if (!companyFilter) {
    return result;
  }

  const company: AutocompleteOption = {
    value: companyFilter.companyId,
    label: companyFilter.companyName,
  };
  result.company = company;

  if (!appliedFilters.branchOffices) {
    return result;
  }

  const branchOfficeFilter = companyFilter.branchOffices.find((bo) =>
    appliedFilters.branchOffices?.includes(bo.branchOfficeId)
  );

  if (!branchOfficeFilter) {
    return result;
  }

  if (!appliedFilters.departments) {
    return result;
  }

  const departmentFilter = branchOfficeFilter.departments.find((dept) =>
    appliedFilters.departments?.includes(dept.departmentId)
  );

  if (!departmentFilter) {
    return result;
  }

  return result;
};
export { getProjectPlanningFiltersDefaultValues };
